import React from "react";
import AvkomRoentgenStatistikk from "./AvkomRoentgenStatistikk";
import BarnebarnRoentgenStatistikk from "./BarnebarnRoentgenStatistikk";
import {withRouter, useHistory } from "react-router-dom";
import qs from "query-string";


const Statistikk = (props) => {
    const avkomRoentgenStatistikk = props.avkomRoentgenStatistikk;
    const barnebarnRoentgenStatistikk = props.barnebarnRoentgenStatistikk;
    const raseRoentgenStatistikk = props.raseRoentgenStatistikk;

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    let label = 'valper';
    if (parsed.statistikLabel !== undefined) {
        label = parsed.statistikLabel;
    }

    const setLabel = (t) => {
        let params = parsed
        if (t !== label) {
            params.statistikLabel = t;
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));

    };

    const getClassNames = (t) => {
        return (label === t)
            ? "tabs-title tab-active"
            : "tabs-title";
    };

    const show = (t) => {
        if (label === t) {
            return true;
        }
        return false;
    };

    return (
        <div className="tabs-content">
            <div className="tab-container">
                <div className="tree-options">
                    <li className={getClassNames('valper')} onClick={() => setLabel("valper")}>
                            <span>HVALPE</span>
                    </li>
                    <li className={getClassNames('barnebarn')} onClick={() => setLabel("barnebarn")}>
                            <span>BØRNEBØRN</span>
                    </li>
                </div>


            </div>
            <div className="tabs-panel is-active" >
                {
                    show('valper') &&
                        <AvkomRoentgenStatistikk avkomStatistikk={avkomRoentgenStatistikk}
                                                 raseStatistikk={raseRoentgenStatistikk} />
                }

                {
                    show('barnebarn') &&
                        <BarnebarnRoentgenStatistikk barnebarnStatistikk={barnebarnRoentgenStatistikk}
                                                     raseStatistikk={raseRoentgenStatistikk} />
                }
            </div>
        </div>
    );
};
export default withRouter (Statistikk);
